module.exports = [{"type":"hash","text":"數據壓縮"},{"type":"normal","text":"WebSocket 行情接口返回的所有數據都進行了 GZIP 壓縮，需要 client 在收到數據之後解壓。"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/websocket/introduce/02_data_compress.json
// module id = CVyP
// module chunks = 3